import { TZDate } from '@date-fns/tz';
import { fromUnixTime, isAfter, isBefore, isSameDay } from 'date-fns';
import type { MembershipSchema, RoleAssigningSchema } from '@zenid/mypage-api';
import { NFDW_EDU_ZEN_UNIVERSITY } from '#/utils/constants';

/**
 * 日本標準時のタイムゾーン
 */
const JST = 'Asia/Tokyo';

/**
 * roleAssining の from と to の到来を元に、現在有効かを判定する
 */
function isRoleActiveCurrently(roleAssigning: RoleAssigningSchema): boolean {
  const currentDate = new TZDate().withTimeZone(JST);
  const fromDate = new TZDate(fromUnixTime(roleAssigning.from), JST);
  // to がある場合、時刻を比較して判定する
  if (roleAssigning.to) {
    const toDate = new TZDate(fromUnixTime(roleAssigning.to), JST);
    return (
      ((isSameDay(currentDate, fromDate) || isAfter(currentDate, fromDate)) && isSameDay(currentDate, toDate)) ||
      isBefore(currentDate, toDate)
    );
  }
  // toがない場合は、fromを達しているかで判断し有効範囲内としてtrueとする
  return isSameDay(currentDate, fromDate) || isAfter(currentDate, fromDate);
}

/**
 * 表示すべき所属情報かどうかを判定する
 */
export function shouldMembershipBeShown(
  membership: MembershipSchema,
  { isCurrentMembership }: { isCurrentMembership?: boolean } = {}
): boolean {
  return membership.roleAssignings.some((roleAssigning: RoleAssigningSchema) => {
    switch (roleAssigning.name) {
      // 表示すべきでない role assigning (ZEN 大学出願者 or 保証人) 以外を持つかを判定
      case NFDW_EDU_ZEN_UNIVERSITY.APPLICANT:
      case NFDW_EDU_ZEN_UNIVERSITY.GUARANTOR: {
        return false;
      }
      default: {
        if (isCurrentMembership) {
          // 出願者 or 保証人以外に、現在有効な role が存在するかどうかを
          return isRoleActiveCurrently(roleAssigning);
        }
        // 出願者 or 保証人以外での role であれば、過去存在していれば membership は表示する
        return true;
      }
    }
  });
}
